import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

/**
 * swiper適用
 * nobreak: PCサイズ表示の場合のswiper解除有無
 */
export default class Slider {
  constructor(nobreak = true, paginationType = "bullets", breakpoint = 767) {
    this.nobreak = nobreak;
    this.paginationType = paginationType;
    this.breakpoint = breakpoint;
    this.swipers = document.querySelectorAll(".js-facility-img-swiper");
    this.swiperInstances = [];
  }

  apply() {
    window.addEventListener("resize", () => {
      this.setting();
    });
    this.setting();
  }

  setting() {
    const width = window.innerWidth;

    // スマートフォンまたは指定したbreakpoint以下のサイズでswiperを適用
    if (width <= this.breakpoint || !this.nobreak) {
      this.swipers.forEach((swiper, index) => {
        const swiperContainer = swiper;

        // すでに初期化されているか確認
        if (!swiperContainer.classList.contains("swiper-initialized")) {
          this.swiperInstances[index] = new Swiper(swiperContainer, {
            modules: [Navigation, Pagination],
            loop: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              type: this.paginationType,
            },
            navigation: {
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            },
          });
        }

        // 画像の枚数に応じてカルーセル下の余白を調整する
        const images = swiperContainer.querySelectorAll(".swiper-slide");
        if (images.length === 1) {
          swiperContainer.style.paddingBottom = "16px";
        } else {
          swiperContainer.style.paddingBottom = "50px";
        }
      });
    } else {
      // PCサイズでswiperを破棄
      this.swiperInstances.forEach((instance) => {
        if (instance && instance.destroy) {
          instance.destroy(true, true);
        }
      });
      this.swiperInstances = []; // インスタンスをリセット
    }
  }
}
